import React from 'react';
import Banner from './Banner';
import GeneralContentLayout08 from '../../generalContent/components/layout_08/GeneralContentLayout';
import GeneralContentLayout09 from '../../generalContent/components/layout_09/GeneralContentLayout';
import GeneralContentLayout10 from '../../generalContent/components/layout_10/GeneralContentLayout';
import localizeContentMapper from '../../common/utils/localizeContentMapper';
import { WorkflowItemCode } from '../../constants';
import { generalContentDefaultConfiguration } from '../../generalContent/constants';
import { GeneralContentProps } from '../../generalContent/interfaces/generalContentProps';
import { useAppSelector } from '../../store/hook';
import { Template, WorkflowItem } from '../../store/interfaces';
import { RoutePageProps } from '../../base/components/Routes';
import { Box } from '@mui/material';
import MenuDialog from './MenuDialog';

const GcLayoutComponentsMap: { [key: string]: React.FC<GeneralContentProps> } = {
  LAYOUT_08: GeneralContentLayout08,
  LAYOUT_09: GeneralContentLayout09,
  LAYOUT_10: GeneralContentLayout10,
};

interface PageProps extends RoutePageProps {
  getNextWorkflowItem?(template?: Template): Promise<void>;
}

export const HomePage = (props: PageProps): React.JSX.Element => {
  const { nestedItems } = useAppSelector((state) => state.firstWorkflowItem);

  return (
    <>
      <Banner getNextWorkflowItem={props.getNextWorkflowItem} />
      <Box position={'relative'}>
        <MenuDialog />
        {nestedItems.map((item: WorkflowItem) => {
          const parsedConfig =
            item.configuration && item.code === WorkflowItemCode.GENCONTENT
              ? JSON.parse(item.configuration).configWidgetJSON
              : generalContentDefaultConfiguration;
          const parsedConfiguration = item
            ? localizeContentMapper(parsedConfig, item.localizedContentMap)
            : parsedConfig;
          return React.createElement(GcLayoutComponentsMap[parsedConfiguration.layout], {
            key: item.id,
            id: item.id,
            ...parsedConfiguration,
          });
        })}
      </Box>
    </>
  );
};
